import React from 'react';
import { Button } from 'components/ui';
import { Input, Modal, Select } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import * as Joi from 'joi';
import { SPAM_WORD_CATEGORY } from './utils';
import { useCreateSpamWord } from 'mutation/spam-word';

const schema = Joi.object().keys({
  word: Joi.string().required(),
  category: Joi.string().required(),
});

export default function CreateSpamWordButton() {
  const { mutateAsync, isLoading } = useCreateSpamWord();
  const [showModal, setShowModal] = React.useState(false);
  const { control, handleSubmit, reset, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      word: '',
      category: 'Urgency',
    },
    resolver: joiResolver(schema),
  });
  return (
    <>
      <Button style={{ marginBottom: 10 }} onClick={() => setShowModal(true)}>
        Create New Spam Word
      </Button>
      <Modal
        okButtonProps={{
          disabled: !formState.isValid,
          loading: isLoading,
        }}
        title="Create New Spam Word"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleSubmit(async values => {
          await mutateAsync({
            ...values,
          });
          setShowModal(false);
          reset();
        })}
      >
        <div className="space-y-4" style={{ marginTop: 10 }}>
          <Controller
            control={control}
            name="word"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <div>
                  <p className="input-name">Word</p>
                  <Input
                    placeholder="Spammy word"
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                </div>
              );
            }}
          />
          <Controller
            control={control}
            name="category"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <div>
                  <p className="input-name">Category</p>
                  <Select
                    style={{ width: '100%' }}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  >
                    {SPAM_WORD_CATEGORY.map(category => (
                      <Select.Option
                        key={category.value}
                        value={category.value}
                      >
                        {category.title}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              );
            }}
          />
        </div>
      </Modal>
    </>
  );
}
